import { cacheFirstConfig, http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { LocationQuery } from 'vue-router';

export class DocumentTypeService {
   async getDocumentTypes(query?: LocationQuery) {
      const response = await http.get<PaginatedResponse<DocumentType>>(`/nxt-employer-document-types`, {
         ...cacheFirstConfig,
         params: { ...query },
      });
      return response.data;
   }
}
